module.exports = __webpack_public_path__ + "static/media/broker-step3.2d79d591.png";